import React, { useState } from "react";
import {
  Modal,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
  Box,
} from "@mui/material";
import { MyExportIcon } from "../Assets/svg/MyIcons";

const ExportDataModal = ({ isOpen, onClose, blobData, data, setSnackbar }) => {
  const [exportOption, setExportOption] = useState("selected");
  const [exportStatus, setExportStatus] = useState(null);
  const [exportError, setExportError] = useState("");

  const handleClose = () => {
    onClose();
    setExportStatus(null);
  };

  const handleExport = async () => {
    if (exportOption === "selected" && data.length === 0) {
      setExportError("Please select at least one record.");
      return;
    }
    setExportError("");

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blobData.blob);
    link.setAttribute("download", blobData.fileName);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(link.href);
    document.body.removeChild(link);
    handleClose();
    setSnackbar({
      open: true,
      message: "Data exported successfully",
      severity: "success",
    });
    return true;
  };

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          textAlign: "center",
          borderRadius: "4px",
          padding: "16px 32px",
        }}
      >
        <Typography variant="h5" className="text-gray-800 fw-bold text-start">
          Export Data
        </Typography>
        <RadioGroup
          aria-label="export-option"
          name="export-option"
          value={exportOption}
          onChange={(e) => setExportOption(e.target.value)}
          sx={{ pt: 4 }}
        >
          <FormControlLabel
            value="selected"
            control={<Radio />}
            label="Export Selected Data"
          />
          <FormControlLabel
            value="all"
            control={<Radio />}
            label="Export All Data"
          />
        </RadioGroup>
        {exportError && (
          <Typography sx={{ mt: 2, color: "red", textAlign: "start" }}>
            {exportError}
          </Typography>
        )}
        {exportStatus === "success" ? (
          <Typography sx={{ mt: 2, color: "green", textAlign: "start" }}>
            Export Successful!
          </Typography>
        ) : null}
        <Box
          sx={{
            pt: 4,
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          <button
            onClick={handleClose}
            className="btn btn-outline btn-outline-primary me-4"
          >
            Cancel
          </button>
          <button
            onClick={handleExport}
            className="btn btn-primary"
            disabled={exportStatus === "success"}
          >
            <MyExportIcon className="text-white h-2 w-2 me-1" /> Export
          </button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ExportDataModal;
